var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollDomRef",staticClass:"material-panel"},[_c('material-list',{ref:"listRef",attrs:{"tplGroupId":_vm.tplGroupId,"projectId":_vm.projectId},on:{"onMaterialClick":_vm.onMaterialClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }